import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import { TextField, DatePicker } from "redux-form-material-ui";
import { Card, CardText } from "material-ui/Card";
import { connect } from "react-redux";
import { RaisedButton, FlatButton } from "material-ui";
import {
	actionCreateFixedContribution,
	actionUpdateFixedContribution
} from "../../actions/FixedContributionActions";
import {
	typeIntegerOrDecimal,
	typeIntegerOrDecimalAndCero,
	required
} from "../../common/validaciones";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import { ROL_ADMIN, ROL_SUB_ADMIN } from "../../common/Constants";
import { FIXED_CONTRIBUTIONS } from "../../config/RoutesConstants";
import Util, { SUCCESS, ERROR, handleSubmitFail } from "../../common/Util";
import UtilPC from "../../common/UtilPC";
import VerticalListFields from "../../components/VerticalListFields/VerticalListFields";
import "./FixedContributions.css";

let _handleSubmitFail;

class FixedContributionForm extends Component {
	constructor(props) {
		super(props);
		let state =
			this.props.modeCRU === MODE_CRU_SHOW
				? this.returnStateShowFixedContribution()
				: {};
		this.state = state;
		this.initializeValues = this.initializeValues.bind(this);
		this.returnOnSubmit = this.returnOnSubmit.bind(this);
		_handleSubmitFail = handleSubmitFail.bind(this);
	}

	componentWillMount() {
		if (
			!this.props.modeCRU ||
			(this.props.rol !== ROL_ADMIN && this.props.rol !== ROL_SUB_ADMIN)
		) {
			this.props.history.push(FIXED_CONTRIBUTIONS);
		} else {
			if (this.props.modeCRU === MODE_CRU_CREATE) {
				this.initializeValues(false);
			} else {
				if (
					this.props.modeCRU === MODE_CRU_UPDATE ||
					this.props.modeCRU === MODE_CRU_SHOW
				) {
					this.initializeValues(true);
				}
			}
		}
	}

	returnStateShowFixedContribution() {
		const state = {
			enableField: true
		};
		return state;
	}

	initializeValues(flag) {
		if (flag) {
			this.setState({
				title: "Modificar Contribución Fija",
				subTitle: "Edite contribución fija"
			});
			const {
				dateFrom,
				dateTo,
				baseSalary,
				specialContribution
			} = this.props.fixedContribution;
			this.props.initialize({
				dateFrom: Util.isoDateToJavascriptDate(dateFrom),
				dateTo: Util.isoDateToJavascriptDate(dateTo),
				baseSalary,
				specialContribution
			});
		} else {
			this.setState({
				title: "Alta contribución fija",
				subTitle: "Agrege contribución fija"
			});
			this.props.initialize({
				dateFrom: null,
				dateTo: null,
				baseSalary: null,
				specialContribution: null
			});
		}
	}

	onSubmit(formValues) {
		const values = JSON.parse(JSON.stringify(formValues));
		values.dateFrom = Util.formatDateToISODate(values.dateFrom);
		values.dateTo = Util.formatDateToISODate(values.dateTo);
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			this.props.actionCreateFixedContribution(values, this.returnOnSubmit);
		} else if (this.props.modeCRU === MODE_CRU_UPDATE) {
			values.id = this.props.fixedContribution.id;
			this.props.actionUpdateFixedContribution(
				this.props.fixedContribution.id,
				values,
				this.returnOnSubmit
			);
		}
	}

	returnOnSubmit(response) {
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			if (response === SUCCESS) {
				Util.showNoty(SUCCESS, "Contribución fija creada");
				this.props.history.push(FIXED_CONTRIBUTIONS);
			} else if (response === ERROR)
				Util.showNoty(ERROR, "Error al crear contribución fija");
		} else if (this.props.modeCRU === MODE_CRU_UPDATE) {
			if (response === SUCCESS) {
				Util.showNoty(SUCCESS, "Contribución fija Modificada");
				this.props.history.push(FIXED_CONTRIBUTIONS);
			} else if (response === ERROR)
				Util.showNoty(ERROR, "Error al modificar contribución fija");
		}
	}

	render() {
		const { handleSubmit } = this.props;
		return (
			<div className="center">
				<Card className="card">
					{UtilPC.renderCardTitleCRU(this.props.modeCRU, "Contribución Fija")}
					<CardText>
						<form>
							<div className="content-papercard">
								<VerticalListFields
									titleText="Fecha Desde"
									titleClass="title-papercard-primary"
									paperClass="papercard top20"
									contentClass="content-papercard-around"
								>
									<div className="columns-row-around">
										<Field
											name="dateFrom"
											component={DatePicker}
											floatingLabelText="Fecha Desde"
											floatingLabelFixed={false}
											hintText="dd/mm/aaaa"
											fullWidth
											formatDate={Util.formatDateToShowNotHour}
											disabled={this.state.enableField}
										/>
										<Field
											name="dateTo"
											component={DatePicker}
											floatingLabelText="Fecha Hasta"
											floatingLabelFixed={false}
											hintText="dd/mm/aaaa"
											fullWidth
											formatDate={Util.formatDateToShowNotHour}
											disabled={this.state.enableField}
										/>
									</div>
								</VerticalListFields>
								<Field
									name="baseSalary"
									component={TextField}
									floatingLabelText="Salario Base"
									validate={[required, typeIntegerOrDecimal]}
									fullWidth
									floatingLabelFixed={false}
									disabled={this.state.enableField}
								/>
								<Field
									name="specialContribution"
									component={TextField}
									floatingLabelText="Contribución especial"
									validate={[required, typeIntegerOrDecimalAndCero]}
									fullWidth
									floatingLabelFixed={false}
									disabled={this.state.enableField}
								/>
							</div>
							<div>
								<FlatButton
									label="Cancelar"
									onClick={() => this.props.history.push(FIXED_CONTRIBUTIONS)}
									style={{ margin: 5 }}
								/>
								<RaisedButton
									label="Aceptar"
									disabled={this.state.enableField}
									primary
									style={{ margin: 5 }}
									onClick={handleSubmit(this.onSubmit.bind(this))}
								/>
							</div>
						</form>
					</CardText>
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		fixedContribution: store.fixedContribution.fixedContribution,
		modeCRU: store.fixedContribution.modeCRU,
		rol: store.app.rol
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionCreateFixedContribution,
			actionUpdateFixedContribution
		},
		dispatch
	);
}

export default reduxForm({
	form: "FixedContributionForm",
	onSubmitFail: errors => _handleSubmitFail(errors)
})(connect(mapStateToProps, mapDispatchToProps)(FixedContributionForm));



// WEBPACK FOOTER //
// ./src/screens/FixedContribution/FixedContributionForm.js